const paths = {
    home: {
        path: "/",
        title: "Vulcan Learning",
        description: "Vulcan Learning is re-Inventing education. Live classes led by experienced industry experts. Enroll instantly."
    },
    ourMission: {
        path: "/about",
        title: "Our Mission | Vulcan Learning",
        description: "Connecting learners directly with subject matter experts - in any subject."
    },
    coursesPage: {
        path: "/courses",
        title: "Courses | Vulcan Learning",
        description: "Vulcan Learning Courses"
    },
    courseListingPage: {
        path: "/courses/:title",
        title: "Course | Vulcan Learning",
        description: "Vulcan Learning is re-Inventing education. Live classes led by experienced industry experts. Enroll instantly."
    },
    howItWorks: {
        path: "/how-it-works",
        title: "How it works | Vulcan Learning",
        description: "Our service connects Learners with Educators offering live educational classes on a wide range of subjects. Here's how it works"
    },
    careersPage: {
        path: "/careers",
        title: "Careers | Vulcan Learning",
        description: "Become an educator on the Vulcan Learning Platform"
    },
    blogPage: {
        path: "/blog",
        title: "Blog | Vulcan Learning",
        description: "Become an educator on the Vulcan Learning Platform"
    },
    blogListingPage: {
        path: "/blog/:title",
        title: "Blog | Vulcan Learning",
        description: "Become an educator on the Vulcan Learning Platform"
    },
    jobListingPage: {
        path: "/careers/listing/:req",
        title: "Careers | Vulcan Learning",
        description: "Become an educator on the Vulcan Learning Platform"
    },
    becomeEducator: {
        path: "/become-educator",
        title: "Become an Educator | Vulcan Learning",
        description: "Become an Educator on the Vulcan Platform. Enrich lives. Earn income."
    },
    educatorFaq: {
        path: "/educator-faq",
        title: "Educator FAQ | Vulcan Learning",
        description: "Find answers to frequently asked questions about becoming an educator on Vulcan Learning. Learn about payments, requirements, and how to get started."
    },
    learnerFaq: {
        path: "/learner-faq",
        title: "Learner FAQ | Vulcan Learning",
        description: "Find answers to frequently asked questions about enrolling in courses on Vulcan Learning. Learn about schedules, costs, requirements, refunds, and educators."
    },
    privacyPage: {
        path: "/privacy",
        title: "Privacy | Vulcan Learning",
        description: "Privacy Policy"
    },
    policiesPage: {
        path: "/policies",
        title: "Policies | Vulcan Learning",
        description: "Terms, Conditions, and Policies"
    },
    cancellationPage: {
        path: "/cancellation-policy",
        title: "Cancellation | Vulcan Learning",
        description: "Cancellation Policy"
    },
    contactPage: {
        path: "/contact",
        title: "Contact | Vulcan Learning",
        description: "Contact Us"
    },
    educators: {
        path: "/educators",
        title: "Profile | Vulcan Learning",
        description: "Learn more about educator on Vulcan Learning. Discover their background, courses, and teaching experience"
    },
    educatorProfilePage: {
        path: "/educators/:name",
        title: "Profile | Vulcan Learning",
        description: "Learn more about educator on Vulcan Learning. Discover their background, courses, and teaching experience"
    },
    accountPage: {
        path: "/account",
        title: "Account | Vulcan Learning",
        description: "Manage your Vulcan Learning account. Update your name, email, phone number, and password securely from one place."
    },
    checkoutPage: {
        path: "/enroll",
        title: "Checkout | Vulcan Learning",
        description: "Securely enroll in your chosen course through Vulcan Learning's checkout page. Fast, safe, and simple enrollment process."
    },
    dashboardPage: {
        path: "/dashboard",
        title: "Dashboard | Vulcan Learning",
        description: "Vulcan Learning Dashboard"
    },
    room: {
        path: "/room",
        title: "Conference Room | Vulcan Learning",
        description: "Join your live Vulcan Learning class in our secure online conference room. Learn, interact, and collaborate seamlessly."
    },
    conferenceRoomPage: {
        path: "/room/:classUrl",
        title: "Conference Room | Vulcan Learning",
        description: "Join your live Vulcan Learning class in our secure online conference room. Learn, interact, and collaborate seamlessly."
    },
    createCoursePage: {
        path: "/create-course",
        title: "Create Course | Vulcan Learning",
        description: "Easily create and manage your online courses with Vulcan Learning. Define basics, set objectives, build curriculum, and schedule classes in a simple step-by-step flow."
    },
    enrollmentCompletePage: {
        path: "/checkout-complete",
        title: "Enrollment Complete | Vulcan Learning",
        description: "Check your enrollment status for your course. View pending, successful, or failed enrollments and access your dashboard for more details."
    },
    onboardingPage: {
        path: "/educator-account",
        title: "Create Account | Vulcan Learning",
        description: "Set up your educator account on Vulcan Learning. Complete profile, share your experience, and start teaching learners worldwide."
    },
    error404: {
        path: "*",
        title: "404  | Vulcan Learning",
        description: "Not Found"
    }
}

export default paths;